export const ALL_VENDOR_REQUEST = "ALL_VENDOR_REQUEST"
export const ALL_VENDOR_SUCCESS = "ALL_VENDOR_SUCCESS"
export const ALL_VENDOR_FAIL = "ALL_VENDOR_FAIL"

export const ALL_VENDOR_POST_REQUEST = "ALL_VENDOR_POST_REQUEST"
export const ALL_VENDOR_POST_SUCCESS = "ALL_VENDOR_POST_SUCCESS"
export const ALL_VENDOR_POST_FAIL = "ALL_VENDOR_POST_FAIL"

export const ALL_VENDOR_UPDATE_REQUEST = "ALL_VENDOR_UPDATE_REQUEST"
export const ALL_VENDOR_UPDATE_SUCCESS = "ALL_VENDOR_UPDATE_SUCCESS"
export const ALL_VENDOR_UPDATE_FAIL = "ALL_VENDOR_UPDATE_FAIL"

export const ALL_VENDOR_DETAILS_REQUEST = "ALL_VENDOR_DETAILS_REQUEST"
export const ALL_VENDOR_DETAILS_SUCCESS = "ALL_VENDOR_DETAILS_SUCCESS"
export const ALL_VENDOR_DETAILS_FAIL = "ALL_VENDOR_DETAILS_FAIL"

export const ALL_VENDOR_DELETE_REQUEST = "ALL_VENDOR_DELETE_REQUEST"
export const ALL_VENDOR_DELETE_SUCCESS = "ALL_VENDOR_DELETE_SUCCESS"
export const ALL_VENDOR_DELETE_FAIL = "ALL_VENDOR_DELETE_FAIL"


export const CLEAR_ERRORS = "CLEAR_ERRORS"